import { auroraOption } from './options/aurora';
import { documentDBOption } from './options/documentdb';
import { dynamoDBOption } from './options/dynamodb';
import { elasticacheOption } from './options/elasticache';
import { amazonRDSOption } from './options/rds';

import { Option } from '../../../shared/options/domain/option';
import { CriteriaKey } from './criteria';

export const databaseOptions: Record<string, Option<CriteriaKey>> = {
  amazonRDSOption,
  auroraOption,
  dynamoDBOption,
  documentDBOption,
  elasticacheOption,
};
